export default (number) => {
    return Math.round(number * 10) / 10
}


// WEBPACK FOOTER //
// ./src/helpers/oneDecimalPlaceFormat.js